import { useEffect, useRef } from 'react';

import { useLazyGetArenaOffersQuery } from '@/api/queries/shop';
import { discountTimer } from '@/redux/reducers/shopReducer';
import {
  checkDiscountTimer,
  expiriesDiscountTimer,
} from '@/redux/selectors/leagues';
import { useAppDispatch, useAppSelector } from '@/redux/store';

export const useArenaOffersTimer = (): boolean => {
  const isTimer = useAppSelector(checkDiscountTimer);
  const isTimerExpiries = useAppSelector(expiriesDiscountTimer);
  const dispatch = useAppDispatch();
  const timerId = useRef<NodeJS.Timeout | undefined>();
  const [getShopInfo] = useLazyGetArenaOffersQuery();

  useEffect(() => {
    const fetchShopInfo = async (): Promise<void> => {
      if (isTimerExpiries) {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        try {
          await getShopInfo().unwrap();
        } catch (error) {
          console.error('Failed to fetch shop info:', error);
        }
      }
    };

    fetchShopInfo();

    if (!isTimer) {
      clearInterval(timerId.current);
    }

    if (isTimer) {
      timerId.current = setInterval(() => dispatch(discountTimer()), 1000);
    }

    return (): void => {
      clearInterval(timerId.current);
      timerId.current = undefined;
    };
  }, [isTimer, isTimerExpiries, dispatch, getShopInfo]);

  return isTimer;
};
